import { useMemo } from 'react';
import { useGetEditorThreadByIdQuery } from 'src/store/services';
import { useGetUser } from '../userHooks';
import { useCurrentThreadId } from './useCurrentThreadId';

export const useGetEditorThread = () => {
  const { user_id } = useGetUser();
  const { currentThreadId } = useCurrentThreadId();

  const { data, isLoading } = useGetEditorThreadByIdQuery(
    {
      user_id,
      thread_id: currentThreadId || '',
    },
    { skip: !currentThreadId },
  );

  return useMemo(
    () => ({
      editorThread: data,
      isEditorLoading: isLoading,
      artifactOutput: data?.artifact,
    }),
    [data, isLoading],
  );
};
